import img from '../images/loader.svg'

export const PageLoading = () => {
    return (<div className="pageLoading">
        <img src={img} alt="404" title="404"/>
    </div>)
}